import { render, staticRenderFns } from "./PaymentFileView.vue?vue&type=template&id=4b5b3337&scoped=true"
import script from "./PaymentFileView.vue?vue&type=script&lang=ts"
export * from "./PaymentFileView.vue?vue&type=script&lang=ts"
import style0 from "./PaymentFileView.vue?vue&type=style&index=0&id=4b5b3337&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5b3337",
  null
  
)

export default component.exports